import styles from "./index.module.scss";
import Breadcrumbs from "../../common/breadcrumbs";

export default function Side({
  title = "",
  children,
  side,
  top = "",
  isShowBreadcrumbs = true,
}) {
  return (
    <div className="container">
      {isShowBreadcrumbs && <Breadcrumbs />}
      {title && <h1>{title}</h1>}
      {top}
      <div className={styles.Content}>
        <div className={styles.Side}>{side}</div>
        <div className={styles.Block}>{children}</div>
      </div>
    </div>
  );
}
